<template>
  <onboarding-container
    :width="1000"
    no-background
  >
    <b-steps
      v-model="currentStep"
      label-position="right"
      size="is-small"
      class="onboarding_steps"
      vertical
      :has-navigation="false"
      :animated="false"
    >
      <b-step-item
        v-for="(step,index) in steps"
        :key="index"
        :value="index.toString()"
        :label="step.label"
        :step="index + 1"
        :clickable="false"
      >
        <component v-bind:is="step.component"/>

        <div class="flex flex-between mt-200">
          <button-outlined v-if="!isLastStep" @click="goToAccount">
            Nevermind, Go To Account
          </button-outlined>

          <button-default class="ml-auto" @click="nextStep" :loading="stepLoading">{{
              isLastStep ? 'Go To Account' : 'Next'
            }}
          </button-default>
        </div>
      </b-step-item>
    </b-steps>
  </onboarding-container>
</template>

<script>
import {defineComponent} from 'vue'
import OnboardingContainer from "./component/OnboardingContainer.vue";
import api from "../../api";
import {SnackbarProgrammatic as Snackbar} from "buefy";

export default defineComponent({
  name: "OnboardingWizard3Page",
  metaInfo: {
    title: "Setup Integrations"
  },
  components: {OnboardingContainer},
  data() {
    return {
      currentStep: 0,
      stepLoading: false,
    }
  },
  mounted() {
    // Need to move past already completed steps
    const chosenIntegrations = this.$store.state.onboarding.onboarding.chosen_integrations;

    this.steps.forEach(step => {
      const integration = chosenIntegrations[step.id];

      if(integration.completed) {
        this.currentStep++
      }
    })
  },
  computed: {
    onboarding() {
      return this.$store.state.onboarding.onboarding;
    },
    step: {
      get() {
        return this.currentStep.toString()
      },
      set(newValue) {
        this.currentStep = Number(newValue)
      }
    },
    steps() {
      return this.$store.getters["onboarding/steps"];
    },
    isLastStep() {
      return Number(this.currentStep) === this.steps.length - 1;
    }
  },
  methods: {
    goToAccount() {
      api.onboarding.markComplete(this.onboarding.id).then((response) => {
        this.$store.commit('onboarding/updateOnboarding', response.data);
        this.$router.push({name: 'pipeline'})
      }).catch(() => {

      })
    },
    nextStep() {
      if (this.currentStep === this.steps.length - 1) {
        api.onboarding.markComplete(this.onboarding.id).then((response) => {
          this.$store.commit('onboarding/updateOnboarding', response.data);
          this.$router.push({name: 'pipeline'})
        }).catch(() => {
          Snackbar.open({
            message: 'Your account was not provisioned. Please contact support@forefrontcrm.com so we can get this sorted out.',
            type: 'is-danger',
            position: 'is-bottom',
            indefinite: true
          });
        })
      } else {
        this.stepLoading = true;

        // Set the current step as completed and save it
        const currentIntegration = this.steps[this.currentStep];
        const chosenIntegrations = this.$store.state.onboarding.onboarding.chosen_integrations;
        chosenIntegrations[currentIntegration.id].completed = true;

        api.onboarding.updateChosenIntegration(this.onboarding.id, chosenIntegrations).then((response) => {
          this.$store.commit('onboarding/updateOnboarding', response.data);
          this.stepLoading = false;
          this.currentStep = this.currentStep + 1;
        })
      }
    }
  },
})
</script>

<style scoped lang="scss">
@import "../../styles/variables/variables";

.onboarding {

  &--heading {
    margin-bottom: 12px;
    font-size: 2rem;
    text-align: center;
  }

  &--text {
    margin-bottom: 10px;
  }

  &--subheading {
    margin-bottom: 8px;
    font-size: 1.25rem;
  }
}
</style>
